"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyStructure = void 0;
/**
 * Record details about an anatomical structure.  This resource may be used when a coded concept does not provide the necessary detail needed for the use case.
 */
var BodyStructure = /** @class */ (function () {
    function BodyStructure() {
    }
    return BodyStructure;
}());
exports.BodyStructure = BodyStructure;
